import { isNil } from "@/common/helpers/lang";

export const canUseDOM = !!(
  typeof window !== "undefined" &&
  !isNil(window.document) &&
  // eslint-disable-next-line @typescript-eslint/unbound-method, @typescript-eslint/no-deprecated -- not necessary warnings
  !isNil(window.document.createElement)
);
